export function getFileKey(file: File) {
  return `${file.name}:${file.size}:${file.lastModified}`;
}

export function getPlanLookupKey(file: Pick<File, "name" | "size">) {
  return `${file.name}:${file.size}`;
}
